<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
          <div class="card">
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>QC Inspection <span class="badge badge-sm bg-gradient-secondary" v-if="totalPending > 0">{{ totalPending }} Pending</span></h6>
                </div>
              </div>
              <div class="col-lg-5">
                <input type="text" class="form-control mt-3" placeholder="Search by Item Name" v-model="search.material_name" v-on:keyup.enter="quickSearch()">
              </div>
              <div class="col-lg-3 float-right">
                <argon-button
                  style="margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="formFilter.show = true"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status QC</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Item Code</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Item Name</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Specification</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Size</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Qty</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PO No.</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tgl Terima</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Requested By</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Pass / Reject</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Inspected By</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-success" v-if="row.result == 'Pass'">Pass</span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.result == 'Reject'">Reject</span>
                        <span class="badge badge-sm bg-gradient-warning" v-else-if="row.result == 'Partial'">Partial</span>
                        <span class="badge badge-sm bg-gradient-secondary" v-else>Pending</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-primary">{{ row.material_code }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.material_name }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.qty }} {{ row.unit }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.po_no }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.qc_requested_by }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold" v-if="row.qc_id">{{ row.qty_pass }} / {{ row.qty_reject }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold" v-if="row.qc_id">{{ row.inspected_by }} <br> {{ moment(row.inspected_at).locale('id').format('LL') }}</span>
                      </td>
                      <td>
                        <i class="fa fa-clipboard fa-sm" aria-hidden="true" :title="row.qc_id ? 'Edit hasil QC' : 'Input hasil QC'" style="cursor: pointer; margin-right: 20px;" @click="openQc(row)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-left">TOTAL ROWS : {{table.data.length}} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL INPUT HASIL QC ======= -->
  <div class="container">
    <vue-final-modal v-model="formQc.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formQc.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formQc.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <label class="form-control-label mt-3">Item</label>
        <input type="text" class="form-control" :value="dataQc.material_code+' - '+dataQc.material_name" disabled>
        <label class="form-control-label mt-3">Qty Inspected <span style="color: red;">*</span></label>
        <input type="number" step="0.01" class="form-control" placeholder="Qty Inspected" v-model="dataQc.qty_inspected">
        <label class="form-control-label mt-3">Qty Pass <span style="color: red;">*</span></label>
        <input type="number" step="0.01" class="form-control" placeholder="Qty Pass" v-model="dataQc.qty_pass">
        <label class="form-control-label mt-3">Qty Reject <span style="color: red;">*</span></label>
        <input type="number" step="0.01" class="form-control" placeholder="Qty Reject" v-model="dataQc.qty_reject">
        <small class="text-danger" v-if="!qtyBalanced">Qty Pass + Qty Reject harus sama dengan Qty Inspected</small>
        <label class="form-control-label mt-3">Tanggal Inspeksi <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="dataQc.inspected_at">
        <label class="form-control-label mt-3">Catatan</label>
        <textarea class="form-control" placeholder="Catatan" v-model="dataQc.note"></textarea>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="formQc.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveQc()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>Save</span>
          </argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">Filter</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <label class="form-control-label mt-3">Status QC</label>
        <select class="form-select" v-model="search.status">
          <option value="">All</option>
          <option value="Pending">Pending</option>
          <option value="Pass">Pass</option>
          <option value="Partial">Partial</option>
          <option value="Reject">Reject</option>
        </select>
        <label class="form-control-label mt-3">Item Name</label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="search.material_name">
        <label class="form-control-label mt-3">PO No.</label>
        <input type="text" class="form-control" placeholder="PO No." v-model="search.po_no">
        <label class="form-control-label mt-3">Tgl Terima</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="search = {status: '', material_name: '', po_no: '', date: ''}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="quickSearch()">Filter</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import qcInspection from '@/services/qcInspection.service';

export default {
  name: "QcInspection",
  components: {
    ArgonButton,
    VueFinalModal,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      moment: moment,
      pagination: {
        page_count: '',
        page: 1,
      },
      table: {
        data: []
      },
      totalPending: 0,
      formQc: {
        title: "QC Inspection",
        show: false
      },
      formFilter: {
        show: false
      },
      dataQc: {},
      onLoading: false,
      search: {
        status: '',
        material_name: '',
        po_no: '',
        date: '',
      },
    };
  },
  computed: {
    qtyBalanced() {
      return (Number(this.dataQc.qty_pass || 0) + Number(this.dataQc.qty_reject || 0)) == Number(this.dataQc.qty_inspected || 0);
    },
  },
  mounted(){
    this.get();
  },
  methods: {
    get(){
      let context = this;
      Api(context, qcInspection.queue({status: context.search.status, material_name: context.search.material_name, po_no: context.search.po_no, date: context.search.date, page: context.pagination.page})).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
          context.totalPending          = response.data.data.totalPending;
      }).onError(function(error) {
          if (error.response && error.response.status == 404) {
              context.table.data   = [];
              context.totalPending = error.response.data.data ? error.response.data.data.totalPending : 0;
          } else {
              context.notify('Data Retrieved Failed', 'error')
          }
      }).onFinish(function() {
          context.formFilter.show = false;
      })
      .call()
    },
    quickSearch() {
      this.pagination.page = 1;
      this.get();
    },
    openQc(row) {
      this.formQc.title = row.qc_id ? 'Edit Hasil QC' : 'Input Hasil QC';
      this.dataQc = {
        id:              row.qc_id,
        barang_masuk_id: row.id,
        material_code:   row.material_code,
        material_name:   row.material_name,
        qty_inspected:   row.qc_id ? row.qty_inspected : row.qty,
        qty_pass:        row.qc_id ? row.qty_pass : '',
        qty_reject:      row.qc_id ? row.qty_reject : '',
        note:            row.qc_id ? row.qc_note : '',
        inspected_at:    row.qc_id ? row.inspected_at : moment().format('YYYY-MM-DD'),
      };
      this.formQc.show = true;
    },
    saveQc() {
      let context = this;

      if (!context.qtyBalanced) {
        return alert('Qty Pass + Qty Reject harus sama dengan Qty Inspected');
      }
      if (!context.dataQc.inspected_at) {
        return alert('Tanggal Inspeksi wajib diisi');
      }

      context.onLoading = true;

      let params = {
        barang_masuk_id: context.dataQc.barang_masuk_id,
        qty_inspected:   context.dataQc.qty_inspected,
        qty_pass:        context.dataQc.qty_pass,
        qty_reject:      context.dataQc.qty_reject,
        note:            context.dataQc.note,
        inspected_at:    context.dataQc.inspected_at,
      };

      let api = (context.dataQc.id) ? Api(context, qcInspection.update(context.dataQc.id, params)) : Api(context, qcInspection.create(params));

      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.formQc.show = false;
        context.get();
        context.notify('Hasil QC Berhasil di Simpan', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify('Hasil QC Gagal di Simpan', 'error')
      }).onFinish(function() {
        context.onLoading = false;
      })
      .call();
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
